<template>
    <div v-if="visible" class="modal fade show d-block" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content rounded-3">
                <div class="modal-body">
                    
                    <div class="container col-12 col-md-8 border bg-light p-3 mt-3 rounded border-primary">
                        <div class="row">
                            <div class="col-md-12 d-flex justify-content-between">
                                <h5 class="text-dark">Buscar</h5>
                                <button type="button" class="btn-sm btn-close float-end fs-7" style="transform: scale(0.8);" @click="handleClose();"></button>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 col-md-6 col-md-4 mt-3">
                                <div class="float-none">
                                    <select class="form-select" @change="changeCategory($event)" v-model="categorySelected" name="select" id="categori">
                                        <option value="0">Categorias</option>
                                        <!-- Verifica se a categoria "Cards" existe e exibe-a se sim -->
                                        <option v-if="hasCategory('COLEÇÕES')" :value="getCategoryId('COLEÇÕES')">Cards</option>
                                        <!-- Verifica se a categoria "Produtos" existe e exibe-a se sim -->
                                        <option v-if="hasCategory('PRODUTOS TCG')" :value="getCategoryId('PRODUTOS TCG')">Produtos TCG</option>
                                        <option id="bracards">Cartas Avaliadas</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-6 mt-4 d-none d-md-block">
                                <h6 class="text-dark px-0">Selecione o tipo de produto</h6>
                            </div>
                        </div>

                        <div class="row mt-3" v-if="collections.length > 0 && categorySelected !== 0">
                            <div class="col-12 col-md-8">
                                <select v-model="collectionSelected" class="form-select py-2">
                                    <option value="0">Edição</option>
                                    <option v-for="collection in collections" :key="collection.id" :value="collection.id">
                                        {{ collection.name }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 col-md-6 mt-3">
                                <div class="float-none">
                                    <select class="form-select" name="orderby" id="short" v-if="is_bra">
                                        <option selected value="1">Avaliação</option>
                                        <option value="2">Encapsulada</option>
                                        <option
                                            v-for="rate in ['Dez (10)', 'Nove (9)', 'Oito (8)', 'Sete (7)', 'Seis (6)', 'Cinco (5)', 'Quatro (4)', 'Três (3)', 'Dois (2)', 'Um (1)']"
                                            :key="rate" :value="rate">
                                            {{ rate }}
                                        </option>
                                    </select>

                                    <select v-model="conditionSelected" @change="changeCondition()" class="form-select" name="orderby"
                                        id="short" v-if="!is_bra" v-bind:disabled="categorySelected === '2'">
                                        <option selected value="0">Qualidade</option>
                                        <option v-for="condition in conditions" :key="condition.id" :value="condition.id">
                                            {{ `${condition?.name} (${condition?.short_name})` }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 mt-3">
                                <div class="float-none">
                                    <select v-model="raritySelected" @change="changeRarity()" class="form-select" name="orderby"
                                    id="short" v-bind:disabled="categorySelected === '2'">
                                        <option selected value="0">Raridade</option>
                                        <option v-for="ratity in rarities" :key="ratity.id" :value="ratity.id">
                                            {{ `${ratity?.name}` }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                    
                        </div>

                        <hr>

                        <div class="row">
                            <div class="d-flex align-items-center float-right">
                                <AutoComplete
                                    v-model="selectedItem"
                                    optionLabel="name"
                                    :suggestions="filtredproducts"
                                    @complete="search"
                                    >
                                    <template #option="slotProps">
                                    <div class="flex align-options-center" style="width: 140px;">
                                        <a :href="'/product/' + slotProps.option.code">
                                        <div
                                            class="col-1 col-md-1 col-sm-1"
                                            style="min-width: 48px; text-align: center; margin-left: -15px;"
                                        >
                                        <!--:alt="slotProps.option.name"-->
                                            <img
                                            :src="slotProps.option.url"
                                            :class="`flag`"
                                            style="max-width: 48px; max-height: 48px"
                                            />
                                        </div>
                                        <div class="col-1 col-md-1 col-sm-1">                         
                                            <div style="margin-left: -10px">
                                                {{ slotProps.option.name }} ({{ slotProps.option.number }}) - {{ slotProps.option.codePro }}
                                            </div>
                                            <div style="margin-left: -10px">
                                                {{ slotProps.option.codeCat }} - {{ slotProps.option.series }}
                                            </div>
                                            <div style="margin-left: -10px">
                                                Lançamento: {{ slotProps.option.date }}
                                            </div>
                                        </div>
                                        </a>
                                    </div>
                                    </template>
                                </AutoComplete>
                                <button class="btn btn-primary ms-1 search-button" @click="performSearch">
                                    Buscar <i class="fa-solid fa-magnifying-glass"></i>
                                </button>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
  
<script>

import AutoComplete from "primevue/autocomplete";


export default {
props: ['visible'],
components: { AutoComplete },
data() {
    return {
        conditionSelected: 0,
        raritySelected: 0,
        orderSelected: 0,
        originSelected: 0,
        categorySelected: 0,
        collectionSelected: 0,
        name: "",
        selectedItem: "",
        product_stat_days: false,
        full: false
    };
},
mounted() {
    if (this.categorySelected) {
      this.fetchCollections(this.categorySelected);
    }
},
watch: {
    categorySelected(newValue) {
      this.fetchCollections(newValue);
    }
},
computed: {
    categories() {
      return this.$store.state.category.categories;
    },
    collections() {
      return this.$store.state.category.collections;
    },
    hasCategory() {
      return (categoryName) => Array.isArray(this.categories) && this.categories.some(category => category.name === categoryName);
    },
    // Obtém o ID da categoria especificada
    getCategoryId() {
      return (categoryName) => {
        const category = this.categories.find(category => category.name === categoryName);
        return category ? category.id : null;
      }
    },
    products() {
      return this.$store.state.product.products;
    },
    filtredproducts() {
      return this.$store.state.product.filter_products;
    },
    rarities() {
      return this.$store.state.attributes.rarities;
    },
    conditions() {
      return this.$store.state.attributes.conditions;
    },
    origins() {
      return this.$store.state.attributes.origins;
    },
    guest() {
      return this.$store.state.user.guest;
    },
},
methods: {
    changeCategory(event) {
      this.product_stat_days = false
      this.categorySelected = event.target.value;

      if (this.categorySelected === '2') {
          this.conditionSelected = 0;
          this.raritySelected = 0;
      }

    },
    fetchCollections(categoryId) {
      if (categoryId && categoryId !== "0") {
        this.$store.dispatch("category/get_collection", categoryId);
      } 
    },
    search(event) {
      this.$store.dispatch("product/get_products", {
        per_page: 20,
        current_page: 1,
        category_id: this.category_id, //category id
        name: event.query,
        type: "filter",
        full: this.full
      });
    },
    performSearch() {
        const queryParams = new URLSearchParams({
          category_id: this.categorySelected,
          collection_id: this.collectionSelected,
          rarity_id: this.raritySelected,
          condition_id: this.conditionSelected,
          origin_id: this.originSelected,
          selectedItem: this.selectedItem
      }).toString();

      const selectedId = this.collectionSelected !== 0 ? this.collectionSelected : this.categorySelected;

      this.$router.push(`/product/list/${selectedId}?${queryParams}`);

      const canvasCloseButton = document.querySelector('.canvas_close');
      if (canvasCloseButton) {
        canvasCloseButton.click(); // Simula um clique para fechar o canvas
      }
              
      $('#Modal').modal('hide');

    },
    handleClose() {
      this.$emit('close');
      $('#Modal').modal('hide');
    },
},

beforeCreate() {
    this.$store.dispatch("category/get_categories");
}
};
</script>

<style>
.p-autocomplete-panel{
   z-index:1055 !important;
}
@media (max-width: 768px) {
    .d-flex {
        width: 100%;
    }

    .search-button {
        white-space: nowrap; /* Evita quebra de linha */
        width: 75%;
    }
}
</style>